import distributorUkraine from 'images/distributorUkraine.jpg';
import distributorGermany from 'images/distributorGermany.jpg';
import distributorKazakhstan from 'images/distributorKazakhstan.jpg';
import distributorMoldova from 'images/distributorMoldova.jpg';

export const contacts = [
    {
        country: 'Ukraine',
        data: {
            image: distributorUkraine,
            name: 'Maksym Zhuravel',
            description: 'Regional sales representative in Kyiv region.',
            phone: '+38 (050) 396 20 60',
            email: 'info@uniferx.com',
        },
    },
    {
        country: 'Germany',
        data: {
            image: distributorGermany,
            name: 'Name',
            description: 'Regional sales representative...',
            phone: '+38 (050) 396 20 60',
            email: 'info@uniferx.com',
        },
    },
    {
        country: 'Kazakhstan',
        data: {
            image: distributorKazakhstan,
            name: 'Name',
            description: 'Regional sales representative...',
            phone: '+38 (050) 396 20 60',
            email: 'info@uniferx.com',
        },
    },
    {
        country: 'Moldova',
        data: {
            image: distributorMoldova,
            name: 'Name',
            description: 'Regional sales representative...',
            phone: '+38 (050) 396 20 60',
            email: 'info@uniferx.com',
        },
    },
];
